module.exports = __webpack_public_path__ + "static/img/new-12.e58b60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-12.png
// module id = 4mCQ
// module chunks = 0